import * as angular from 'angular';

export class MaterialsFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    get(companyId, params) {
        return this.$http.get(
            `${this.apiRoot}/${companyId}/materials/`,
            { params }
        );
    }
}

angular
    .module('app')
    .service('MaterialsFactory', MaterialsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/materials.factory.ts